import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "grid grid-flow-col auto-cols-max lg:grid-cols-2 lg:grid-flow-row lg:auto-cols-auto lg:gap-2 p-0.5 bg-white relative" }
const _hoisted_2 = {
  id: "imageIdx-1",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_3 = { class: "aspect-square bg-gray-100 flex items-center justify-center relative group w-full h-full" }
const _hoisted_4 = {
  key: 0,
  class: "absolute bottom-2 left-1/2 -translate-x-1/2 rounded-lg bg-brand-main/60 px-2 py-0.5 text-[8px] uppercase tracking-widest text-white z-50 pointer-events-none"
}
const _hoisted_5 = {
  key: 0,
  id: "imageIdx1",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_6 = { class: "p-20 flex items-center justify-center h-full" }
const _hoisted_7 = ["src", "srcset"]
const _hoisted_8 = {
  id: "imageIdx2",
  class: "w-screen lg:w-full bg-white snap-center lg:snap-align-none",
  style: {"aspect-ratio":"1/1"}
}
const _hoisted_9 = { class: "p-4 flex items-center justify-center h-full" }

import itemImage from '@/components/itemImage.vue'
import {computed, ref, watch, onMounted} from "vue";
import Diamond360Defaults from "@/components/diamonds/diamond360Defaults.vue";
import { PanchImages } from '@/assets/ts/PanchImages';


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondImages',
  props: {
    certificate: {},
    diamond: {},
    imageIdx: {}
  },
  emits: [
  "switchImage"
],
  setup(__props: any, { emit: __emit }) {

const host = process.env.VUE_APP_HOST || "";

const props = __props

const certificateUrl = computed(() => {
  return props.certificate;
});

const toConfidence = () => {
  window.open('/diamanten/5cs#confidence', '_blank');
}

const emits = __emit;

let isProgrammaticScroll = false;
let timeout: any = null;

const watchScroll = () => {
  if (isProgrammaticScroll || !scrollContainer.value) return;
  getImageInViewport();
}

const panchImageUrl = ref('');
const scrollContainer = ref<HTMLElement | null>(null);

const checkPanchImage = async () => {
  if (!props.diamond.image_url && props.diamond.certificate) {
    const panch = new PanchImages();
    panchImageUrl.value = (await panch.getStill(props.diamond.certificate)) as string;
  } else {
    panchImageUrl.value = '';
  }
};

onMounted(checkPanchImage);

const realImageUrl = computed(() => {
  return props.diamond.image_url || panchImageUrl.value;
});

const defaultImageUrl = computed(() => {
  return (process.env.VUE_APP_HOST || "") + "/img/diamonds/cuts/cut_" + props.diamond.form.toLowerCase() + "@2x.jpg";
});

watch(
    () => props.diamond,
    checkPanchImage,
    {deep: true},
);

watch(
    () => props.imageIdx,
    (imageIdx: string | number | undefined) => {
      if (imageIdx === undefined) return;
      isProgrammaticScroll = true;
      if (timeout) clearTimeout(timeout);

      scrollContainer.value?.querySelector("#imageIdx" + imageIdx)?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });

      // Reset the flag after the smooth scroll is likely finished
      timeout = setTimeout(() => {
        isProgrammaticScroll = false;
      }, 500);
    },
    {deep: true},
);

const getImageInViewport = () => {
  checkImgaeInViewport("imageIdx-1", "-1")
  checkImgaeInViewport("imageIdx0", "0")
  checkImgaeInViewport("imageIdx1", "1")
  checkImgaeInViewport("imageIdx2", "2")
}

const checkImgaeInViewport = (nodeId: string, imagePoxIdx: string) => {
  const el = scrollContainer.value?.querySelector("#" + nodeId) as HTMLElement;
  if (!el) return;

  const rect = el.getBoundingClientRect();
  const parent = scrollContainer.value; // The scroll container
  if (!parent) return;

  const parentRect = parent.getBoundingClientRect();

  // Check if the center of the element is within the viewport of the scroll container
  const elementCenter = rect.left + rect.width / 2;
  const parentCenter = parentRect.left + parentRect.width / 2;

  // If the element is mostly visible in the center (allowing some margin)
  if (Math.abs(elementCenter - parentCenter) < rect.width / 2) {
    emits('switchImage', imagePoxIdx)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollContainer",
    ref: scrollContainer,
    class: "w-full overflow-x-auto overflow-y-hidden sticky snap-x snap-mandatory lg:snap-none no-scrollbar scroll-smooth",
    onScrollPassive: watchScroll
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(itemImage, {
            "image-url": realImageUrl.value || defaultImageUrl.value,
            zoom: true
          }, null, 8, ["image-url"]),
          (!realImageUrl.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('components.diamonds.details.DiamondImages.example_image')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      false
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                onClick: toConfidence,
                src: `${_unref(host)}/img/diamonds/diamond_details_images_sustainable@1x.png`,
                srcset: `${_unref(host)}/img/diamonds/diamond_details_images_sustainable@2x.png`,
                alt: "",
                class: "w-full my-auto cursor-pointer"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Diamond360Defaults, {
            certificate: __props.diamond.certificate,
            image_url: __props.diamond.image_url,
            "diamond-form": __props.diamond.form
          }, null, 8, ["certificate", "image_url", "diamond-form"])
        ])
      ])
    ])
  ], 544))
}
}

})